import {
  CalendarWithTemplate,
  CreateMessageTemplateDto,
  MessageTemplateDto,
  UpdateMessageTemplateDto,
} from '../core/message-templates';
import type { HttpClient } from './http';
import { catch404ReturnNull } from './util';

export interface MessageTemplatesService {
  getMessageTemplates: () => Promise<MessageTemplateDto[]>;
  getMessageTemplateById: (id: string) => Promise<MessageTemplateDto | null>;
  createMessageTemplate: (
    dto: CreateMessageTemplateDto,
  ) => Promise<MessageTemplateDto>;
  updateMessageTemplate: (
    id: string,
    dto: UpdateMessageTemplateDto,
  ) => Promise<MessageTemplateDto>;
  deleteMessageTemplate: (id: string) => Promise<void>;
  setAsDefault: (id: string) => Promise<MessageTemplateDto>;
  listCalendarsWithTemplates: () => Promise<CalendarWithTemplate[]>;
}

export function createMessageTemplatesService(
  httpClient: HttpClient,
  baseUrl: string,
): MessageTemplatesService {
  return {
    getMessageTemplates: () => {
      return httpClient<MessageTemplateDto[]>(
        `${baseUrl}/message-templates`,
        'get',
      );
    },

    getMessageTemplateById: (
      id: string,
    ): Promise<MessageTemplateDto | null> => {
      return catch404ReturnNull(() =>
        httpClient<MessageTemplateDto>(
          `${baseUrl}/message-templates/${id}`,
          'get',
        ),
      );
    },

    createMessageTemplate: (dto: CreateMessageTemplateDto) => {
      return httpClient<MessageTemplateDto>(
        `${baseUrl}/message-templates`,
        'post',
        { body: dto },
      );
    },

    updateMessageTemplate: (id: string, dto: UpdateMessageTemplateDto) => {
      return httpClient<MessageTemplateDto>(
        `${baseUrl}/message-templates/${id}`,
        'patch',
        { body: dto },
      );
    },

    deleteMessageTemplate: (id: string) => {
      return httpClient<void>(`${baseUrl}/message-templates/${id}`, 'delete');
    },

    setAsDefault: (id: string) => {
      return httpClient<MessageTemplateDto>(
        `${baseUrl}/message-templates/${id}/set-as-default`,
        'post',
      );
    },

    listCalendarsWithTemplates: () => {
      return httpClient<CalendarWithTemplate[]>(
        `${baseUrl}/message-templates/calendars-with-templates`,
        'get',
      );
    },
  };
}
